import { SidebarMenuGroup, SidebarMenuItem } from './models/common.model';

/**
 * The whole navigation, defined once. The sidebar renders it and the login screen walks it to
 * pick a landing page, so both agree on what a designation can reach and in what order.
 */
export const MENU_GROUPS: SidebarMenuGroup[] = [
  {
    title: '',
    items: [{ label: 'Dashboard', icon: 'bi-speedometer2', route: '/dashboard' }],
  },
  {
    title: 'Sales',
    items: [
      { label: 'Orders', icon: 'bi-cart-check', route: '/orders', module: 'orders' },
      { label: 'Payments', icon: 'bi-credit-card', route: '/payments', module: 'payments' },
      { label: 'Dealers', icon: 'bi-building-check', route: '/dealers', module: 'dealers' },
      { label: 'Farmers', icon: 'bi-flower1', route: '/farmers', module: 'farmers' },
      { label: 'Visits', icon: 'bi-geo-alt', route: '/party-visits', module: 'visits' },
    ],
  },
  {
    title: 'Inventory',
    items: [
      { label: 'Products', icon: 'bi-archive', route: '/products', module: 'products' },
      { label: 'Raw Material', icon: 'bi-capsule', route: '/raw-material-inventory', module: 'raw_material' },
      { label: 'Production', icon: 'bi-sliders', route: '/production-inventory', module: 'production' },
      { label: 'Inventory', icon: 'bi-box2-heart', route: '/inventory', module: 'inventory' },
    ],
  },
  {
    title: 'Workforce',
    items: [
      { label: 'Employees', icon: 'bi-person-badge', route: '/employees', module: 'employees' },
      { label: 'Attendance', icon: 'bi-calendar2-check', route: '/attendance', module: 'attendance' },
      { label: 'Expenses', icon: 'bi-receipt', route: '/expenses', module: 'expenses' },
      { label: 'Sales Team', icon: 'bi-diagram-3', route: '/sales-team-management', adminOnly: true },
    ],
  },
  {
    title: 'Setup',
    items: [{ label: 'Masters', icon: 'bi-database-gear', route: '/master', module: 'master' }],
  },
];

/**
 * The sidebar permission that decides whether a menu item is visible at all. `module` is the
 * backend permission module, not a display grouping: it has to match the tree exactly, so
 * 'raw_material' resolves to ui_raw_material.sidebar.view.
 */
export function sidebarPermissionCode(item: SidebarMenuItem): string {
  const menuName = item.module || item.label.toLowerCase().replace(/ /g, '_');

  return `ui_${menuName}.sidebar.view`;
}

/**
 * The first menu entry the user can open, in sidebar order, or null when the designation carries
 * admin site login but no module at all. The caller decides where null lands.
 */
export function firstAccessibleRoute(hasPermission: (code: string) => boolean): string | null {
  for (const group of MENU_GROUPS) {
    for (const item of group.items) {
      // Admin-only screens carry no permission code, so they are never a landing page.
      if (item.route && !item.adminOnly && hasPermission(sidebarPermissionCode(item))) {
        return item.route;
      }
    }
  }

  return null;
}
